import { render } from "./AshglyphPrivacy.vue?vue&type=template&id=08428e06&scoped=true"
import script from "./AshglyphPrivacy.vue?vue&type=script&lang=js"
export * from "./AshglyphPrivacy.vue?vue&type=script&lang=js"

import "./AshglyphPrivacy.vue?vue&type=style&index=0&id=08428e06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08428e06"]])

export default __exports__